angular
    .module('empower.control')
    .directive("businessUnitDropdown", ['$rootScope', '$timeout', 'dropdownService',
        function ($rootScope, $timeout, dropdownService) {
            return {
                restrict: 'E',
                require: ['ngModel'],
                templateUrl: 'module/control/searchDropdown/search-business-unit-dropdown.html',
                scope: {
                    ngModel: '=',
                    ngRequired: '=',
                    inputName: '=',
                    inputFormGroup: '='
                },
                controller: function ($scope) {
                    dropdownService.searchBusinessUnits(111).then(function (data) {
                        $scope.listBusinessUnits = data;
                        
                        $('#business-unit-id').select2({
                            placeholder: "Search for employer name"
                        });
                        $('#business-unit-id').on('select2:close', function (e) {
                            $scope.inputFormGroup[$scope.inputName].$setTouched();
                            $scope.$apply();
                        });
                        $scope.$watch(
                            'ngModel', function (newValue) {
                                $timeout(function() {
                                    $('#business-unit-id').trigger('change');
                                }, 0);
                            }
                        )
                    });
                }, // controller
                link: function (scope, element, attrs) {
                    
                } // link
            };
        }
    ])
